"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertLangTitleLinkToSingleLink = void 0;
var react_1 = __importDefault(require("react"));
var index_1 = require("../index");
var basicSingleLink_1 = __importDefault(require("../static/basicSingleLink"));
var defaultButtonTitle = '中/Eng';
exports.convertLangTitleLinkToSingleLink = function (_a) {
    var title = _a.title;
    return (__assign(__assign({}, basicSingleLink_1.default), { title: title }));
};
var LangMenuLinksItem = function (props) {
    var _a = props.buttonTitle, buttonTitle = _a === void 0 ? defaultButtonTitle : _a, langTitleLocaleList = props.langTitleLocaleList, changeLangFn = props.changeLangFn;
    var convertedLink = __assign(__assign({}, basicSingleLink_1.default), { title: buttonTitle, children: langTitleLocaleList.map(function (titleLocale) { return (exports.convertLangTitleLinkToSingleLink(titleLocale)); }) });
    var handleChangeLang = langTitleLocaleList.map(function (t) {
        return function () {
            changeLangFn && changeLangFn(t.locale);
        };
    });
    return (react_1.default.createElement(index_1.MenuWithLinksItem, { onClickFns: handleChangeLang, link: convertedLink }));
};
exports.default = LangMenuLinksItem;
